module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/kitchen/kitchen.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/kitchen/kitchen.png
// module id = 584
// module chunks = 0